import React from "react";
/** @jsxImportSource @emotion/react */
import { css } from "@emotion/react";
import AssetInputOrUploadSection from "./AssetInputOrUploadSection";
import { CREATIVE_ASSET_TYPES, CREATIVE_NAMES, DESKTOP_MARQUEE_AD_FIELDS } from "./definitions";
import VideoAssetCreativeType from "./VideoAssetCreativeType";
import BaseCreativeControls from "./BaseCreativeControls";
import { InputSwitch } from "primereact/inputswitch";

const CREATIVE_TYPE = CREATIVE_NAMES.DESKTOP_MARQUEE

export default function DesktopMarquee({
    handleChange,
    currentCustomer,
    impressionTag,
    clickTag,
    vastUrl,
    vastDuration,
    videoCreativeType,
    adServingType,
    displayCreativeUrl,
    expandedCreativeUrl,
    videoCreativeUrl
}) {
    return (
        <>
            <BaseCreativeControls
                adServingType={adServingType}
                changeHandler={handleChange}
                clickTag={clickTag}
                impressionTag={impressionTag}
                creativeType={CREATIVE_TYPE}
            >
                <AssetInputOrUploadSection
                    inputValue={expandedCreativeUrl}
                    inputLabel="Desktop Banner"
                    inputName={DESKTOP_MARQUEE_AD_FIELDS.expandedCreativeUrl}
                    inputChangeHandler={handleChange}
                    inputAdtype={CREATIVE_TYPE}
                    isRequired={true}
                    currentCustomer={currentCustomer}
                    accept="image/*"
                    defaultExtension="jpeg"
                />
                <AssetInputOrUploadSection
                    inputValue={displayCreativeUrl}
                    inputLabel="Collapsed Banner"
                    inputName={DESKTOP_MARQUEE_AD_FIELDS.displayCreativeUrl}
                    inputChangeHandler={handleChange}
                    inputAdtype={CREATIVE_TYPE}
                    isRequired={true}
                    currentCustomer={currentCustomer}
                    accept="image/*"
                    defaultExtension="jpeg"
                />
                <VideoAssetCreativeType
                    dropdownLabel="Video Creative Type"
                    types={CREATIVE_ASSET_TYPES}
                    videoCreativeTypePropertyName={DESKTOP_MARQUEE_AD_FIELDS.videoCreativeType}
                    videoCreativeType={videoCreativeType || 'video'}
                    handleChange={handleChange}
                    CREATIVE_TYPE={CREATIVE_TYPE}
                    currentCustomer={currentCustomer}
                    videoUrlInputLabel="Video URL"
                    videoUrlInputName={DESKTOP_MARQUEE_AD_FIELDS.videoCreativeUrl}
                    videoUrl={videoCreativeUrl}
                    vastUrl={vastUrl}
                    vastInputName={DESKTOP_MARQUEE_AD_FIELDS.vastUrl}
                    vastDurationInputName={DESKTOP_MARQUEE_AD_FIELDS.vastDuration}
                    vastDuration={vastDuration}
                />
            </BaseCreativeControls>

        </>
    );
}